import React from 'react'

export default function GetUrl() {

    return "https://supertools.livefactura.com/livefactura/"


    //return "http://localhost:3004/livefactura/" // desarollo
    
}
